import React, {useCallback, useMemo} from "react";
import {LogoutRounded} from "@mui/icons-material";
import {EndActionType} from "../index";
import {useDispatch} from "react-redux";
import {setReduxDialogState} from "../../../../redux/slices/dialogs/actions";
import ReduxStoreRoutes from "../../../../../core/models/static/routes/redux-store-routes";
import {useTranslation} from "react-i18next";
import CacheService from "../../../../../core/services/cache/cache_service";

const useLogoutEndAction = (): EndActionType => {
    const dispatch = useDispatch();
    const {t} = useTranslation("components", {keyPrefix: 'panel-sections.app-bar.actions.logout'});

    /**
     * Navigates the user into the logout viw after their confirmation
     */
    const logout = useCallback(() => {
        dispatch(setReduxDialogState(ReduxStoreRoutes.dialogs.confirmation, {
            open: true,
            title: t(t => t.title),
            description: t(t => t.confirmationDescription),
            maxWidth: 'sm',
            fullWidth: true,
            onClose: async (confirmed) => {
                if (confirmed) {
                    await CacheService.logout(true);
                }
                return true;
            }
        }));
    }, [dispatch, t])

    return useMemo<EndActionType>(() => ({
        key: "logout",
        title: t(t => t.title),
        icon: <LogoutRounded/>,
        color: "error",
        onClick: logout,
    }), [logout, t])

}

export default useLogoutEndAction;
